export default "__VITE_ASSET__Cko8vYm2__"